// extracted by mini-css-extract-plugin
module.exports = {"custom-personal-info":"personalInfoSkydropx_custom-personal-info__16tnk","title-personal-info":"personalInfoSkydropx_title-personal-info__3IFdb"};